import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";

import { cn } from "../../common/u1/cn";
import { Button } from "../../common/u1/Button";
import { SearchIconCompact } from "../../../assets/ui/icons";
import { useCompanySearch } from "../../public/Search/u1/useCompanySearch";

/* "You have not claimed a business yet." The design gives My Businesses and Membership the same empty state — a mark, a heading, a line of explanation, a... */
export const ClaimFirstEmptyState = ({
  icon,
  title,
  children,
  className = "",
}) => {
  const inputRef = useRef(null);
  const [error, setError] = useState("");
  const { search } = useCompanySearch();

  const submit = (e) => {
    e?.preventDefault?.();
    setError(search(inputRef.current?.value) || "");
  };

  return (
    <section
      className={cn(
        "rounded-[18px] border border-[var(--line)] bg-white px-6 py-12 text-center",
        "shadow-[0_1px_2px_rgba(20,40,60,.03)]",
        className
      )}
    >
      <span
        aria-hidden="true"
        className={cn(
          "mx-auto mb-6 flex h-[72px] w-[72px] items-center justify-center",
          "rounded-full bg-[var(--field-inset)] text-[var(--muted-2)]"
        )}
      >
        {icon}
      </span>

      <h2 className="m-0 text-[21px] font-bold tracking-[-0.01em] text-[var(--ink)] font-sans">
        {title}
      </h2>

      <p className="mx-auto mt-2.5 max-w-[520px] text-[13.5px] leading-[1.6] text-[var(--ink-2)] font-sans">
        {children}
      </p>

      {/* A form, so Enter submits as well as the button. */}
      <form
        onSubmit={submit}
        className="mx-auto mt-6 flex w-full max-w-[620px] flex-col items-stretch gap-2.5 sm:flex-row"
      >
        <div className="relative min-w-0 grow">
          <span
            aria-hidden="true"
            className="pointer-events-none absolute left-3.5 top-1/2 -translate-y-1/2 text-[var(--muted-2)]"
          >
            <SearchIconCompact />
          </span>
          <input
            ref={inputRef}
            type="text"
            aria-label="Business name or trade licence number"
            placeholder="Business name or trade licence number"
            onChange={() => error && setError("")}
            aria-invalid={error ? true : undefined}
            aria-describedby={error ? "claim-first-error" : undefined}
            className={cn(
              "h-12 w-full rounded-[10px] border bg-white pl-10 pr-3.5",
              "text-[14px] text-[var(--ink)] font-sans",
              "focus:outline-none focus:border-[var(--orange)]",
              "focus:shadow-[0_0_0_4px_var(--focus-ring)]",
              error ? "border-[var(--coral)]" : "border-[var(--field-border)]"
            )}
          />
        </div>

        <Button type="submit" variant="primary" className="h-12 shrink-0 px-6">
          Find my business
        </Button>
      </form>

      {error && (
        <p
          id="claim-first-error"
          role="alert"
          className="mt-2 text-[12.5px] text-[var(--coral-deep)] font-sans"
        >
          {error}
        </p>
      )}

      <p className="mt-4 text-[13px] text-[var(--muted)] font-sans">
        Not on TREVEX yet?{" "}
        <Link
          to="/sign-up"
          state={{ redirectToStep: 6 }}
          className="font-bold text-[var(--coral)] hover:text-[var(--coral-deep)]"
        >
          List your business. It is free.
        </Link>
      </p>
    </section>
  );
};

export default ClaimFirstEmptyState;
